import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/vetting' },
    { path: '/login', name: 'login', component: () => import('../views/LoginView.vue'), meta: { public: true } },
    { path: '/vetting', name: 'vetting', component: () => import('../views/VettingQueueView.vue'), meta: { tab: 'vetting' } },
    { path: '/vetting/:id', name: 'worker-360', component: () => import('../views/Worker360View.vue'), meta: { tab: 'vetting' } },
    { path: '/disputes', name: 'disputes', component: () => import('../views/DisputesView.vue'), meta: { tab: 'disputes' } },
    { path: '/payouts', name: 'payouts', component: () => import('../views/PayoutsView.vue'), meta: { tab: 'payouts', need: 'money' } },
    { path: '/orgs', name: 'orgs', component: () => import('../views/OrgsView.vue'), meta: { tab: 'orgs' } },
    { path: '/rates', name: 'rates', component: () => import('../views/RatesView.vue'), meta: { tab: 'rates' } },
    { path: '/courses', name: 'courses', component: () => import('../views/CoursesView.vue'), meta: { tab: 'courses' } },
    { path: '/metrics', name: 'metrics', component: () => import('../views/MetricsView.vue'), meta: { tab: 'metrics' } },
    { path: '/audit', name: 'audit', component: () => import('../views/AuditView.vue'), meta: { tab: 'audit' } },
    { path: '/:pathMatch(.*)*', redirect: '/vetting' },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(to => {
  const auth = useAuthStore()

  if (to.meta.public) return auth.isAuthenticated ? { name: 'vetting' } : true
  if (!auth.isAuthenticated) return { name: 'login' }

  // Route-level role gates. The server enforces these too — hiding a nav
  // item is not access control, and neither is this on its own.
  const need = to.meta.need as keyof typeof auth.can | undefined
  if (need && !auth.can[need]) return { name: 'vetting' }

  return true
})

export default router
